import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=cddb30d4&scoped=true"
import script from "./tabla.js?vue&type=script&lang=js&external"
export * from "./tabla.js?vue&type=script&lang=js&external"
import style0 from "./tabla.scss?vue&type=style&index=0&id=cddb30d4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddb30d4",
  null
  
)

export default component.exports